<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates"
                    name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" :disabled="getRoleId == 7" v-model="branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-2 col-form-label text-right">
                Personal Trainer
              </div>
              <div class="col-sm-10">
                <div class="custom-search-select">
                  <model-select @input="fetchData()" :options="optionsPT" class="border-bottom"
                    v-model="personal_trainer_id" name="personal_trainer_id"></model-select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4" v-if="getRoleId == 1 || getRoleId == '1'">
            <table>
              <tr>
                <td><a @click="exportReportForAdmin()" class="btn-secondary mr-5"><i
                      class="far fa-file-alt mr-5"></i>Export</a></td>
                <td><a @click="updatePtPrices('update_pt_price')" class="btn-secondary mr-5"><i
                      class="far fa-file-alt mr-5"></i>update pt price</a></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table class="table-custom" @sort-changed="sortingChanged" :hover="hover" :striped="striped"
          :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields"
          :current-page="currentPage">
          <template v-slot:cell(date)="data">
            <!--          <template slot="date" slot-scope="data">-->
            {{ parseDate(data.item.date) }}
          </template>
          <template v-slot:cell(member_id)="data">
            <!--          <template slot="member_id" slot-scope="data">-->
            <div
              v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.member">
              <template v-if="data.item.transaction_detail.member_pt_session.member.branch">
                {{ data.item.transaction_detail.member_pt_session.member.branch.codename }}{{
                  data.item.transaction_detail.member_pt_session.member.id }}
              </template>
              <template v-else>
                FT{{ data.item.transaction_detail.member_pt_session.member.id }}
              </template>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(member_name)="data">
            <!--          <template slot="member_name" slot-scope="data">-->
            <div
              v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.member">
              {{ data.item.transaction_detail.member_pt_session.member.first_name }}
              {{ data.item.transaction_detail.member_pt_session.member.last_name }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(employee_id)="data">
            <!--          <template slot="employee_id" slot-scope="data">-->
            <div v-if="data.item.transaction_detail.member_pt_session">
              {{ data.item.transaction_detail.member_pt_session.personal_trainer_id }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(employee_name)="data">
            <!--          <template slot="employee_name" slot-scope="data">-->
            <div
              v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.personal_training">
              {{ data.item.personal_training.name }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(training_product)="data">
            <!--          <template slot="training_product" slot-scope="data">-->
            <div
              v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.pt_session">
              PT {{ data.item.transaction_detail.member_pt_session.pt_session.training_product }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(is_manual_running)="data">
            <template>
              <b-badge v-if="data.item.is_manual_running == 1" :variant="'success'">Yes</b-badge>
              <b-badge v-if="data.item.is_manual_running == 0" :variant="'warning'">No</b-badge>
              <b-badge v-if="data.item.is_manual_running == 2" :variant="'info'">Auto</b-badge>
            </template>
          </template>
          <template v-slot:cell(category)="data">
            <template>
              <div
                v-if="data.item.transaction_detail.member_pt_session && data.item.transaction_detail.member_pt_session.member_session_attendance">
                <template v-if="data.item.is_manual_running == 2">
                  Auto
                </template>
                <template v-else>
                  {{ data.item.transaction_detail.member_pt_session.member_session_attendance.attendance_category.name
                  }}
                </template>

              </div>
              <div v-else>-</div>
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- show modal -->
    <b-modal modal-class="modal-custom-image" size="xl" :ref="'update_pt_price'" scrollable title="Update PT Price">
      <div class="row">
        <div class="col-md-12">
          <!-- link example -->
           Example File: <a href="https://drive.google.com/drive/folders/1ZwumeUSqHDZ4nllzXBwD2bDnds9tKosg?usp=sharing" target="_blank">Download here</a>
        </div>
        <div class="col-md-12">
          <ExcelUploader @excelLoaded="updatePtPriceListener" />
        </div>
      </div>
      <template #modal-footer="{ ok, cancel, hide }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="success" @click="uploadPtPrices()">
          Upload
        </b-button>
        <b-button size="md" variant="danger" @click="hide()">
          Cancel
        </b-button>
      </template>
    </b-modal>

    <!-- loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'

import ExcelUploader from '@/views/component/ExcelUploader'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination,
    ExcelUploader,
    ModelSelect
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'date',
          label: 'Date',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: true
        },
        {
          key: 'usage_number',
          label: 'Usage Number',
          sortable: false
        },
        {
          key: 'start_usage',
          label: 'Start Usage',
          sortable: false
        },
        {
          key: 'training_product',
          label: 'Training Product',
          sortable: false
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'checkIn',
          label: 'Check In',
          sortable: false
        },
        {
          key: 'checkOut',
          label: 'Check Out',
          sortable: false
        },
        {
          key: 'employee_id',
          label: 'Employee ID',
          sortable: false
        },
        {
          key: 'employee_name',
          label: 'PT Name',
          sortable: false
        },
        {
          key: 'personal_training.branch.name',
          label: 'PT Branch',
          sortable: false
        },
        {
          key: 'is_manual_running',
          label: 'Manual Running',
          sortable: false
        },
        {
          key: 'category',
          label: 'Category',
          sortable: false
        }
      ],
      items: [],
      ptPriceData: [],
      optionsPT: [
        { value: null, text: 'Please select' }
      ],
      dataBranch: [],
      branch_id: Auth.Session.get().paradigm_branch_id == 0 ? null : Auth.Session.get().paradigm_branch_id,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      personal_trainer_id: null,
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.exportDates = dateStr + ' to ' + dateStr
        } else {
          this.exportDates = dateStr
        }
        if (this.exportDates.includes(" to ") === true) {
          this.fetchData()
        }
      }
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', { maximumFractionDigits: 0 })
    },
    openPage(event) {
      this.$router.push(event)
    },
    editGallery(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg(value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      let export_url
      if (Auth.Session.get().paradigm_role == 7) {
        export_url = 'crm/v1/export/pt_report/usage_log?start_date=' + dates[0] + '&end_date=' + dates[1] + '&personal_trainer_id=' + Auth.Session.get().paradigm_id
      } else {
        export_url = 'crm/v1/export/pt_report/usage_log?start_date=' + dates[0] + '&end_date=' + dates[1]
      }

      if (this.branch_id != null) {
        export_url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: export_url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Usage Log (PT Report) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    exportReportForAdmin() {
      let dates = this.exportDates.split(' to ')
      let export_url = 'crm/v1/export/pt_report/usage_log/admin_only?start_date=' + dates[0] + '&end_date=' + dates[1]

      axios({
        method: 'get',
        url: export_url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Usage Log (PT Report) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    updatePtPrices(modalId) {
      this.$refs[modalId].show()
    },
    updatePtPriceListener(json) {
      // console.log(json)
      this.ptPriceData = JSON.parse(json)
    },
    uploadPtPrices() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes upload now!',
        cancelButtonText: 'No, Cancel!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.loadingActive = true

          // format property to snake case
          for (let i = 0; i < this.ptPriceData.length; i++) {
            // format property to snake case
            const el = this.ptPriceData[i];
            for (const [key, value] of Object.entries(el)) {
              el[this.toSnakeCase(key)] = value
              // delete current key
              delete el[key]
            }
          }

          // console.log(this.ptPriceData)
          axios.post('crm/v1/pt_report/update_pt_price', this.ptPriceData).then(response => {
            this.loadingActive = false
            this.$refs['update_pt_price'].hide()
            this.$swal('Data Updated', 'You successfully updated this file', 'success')
            this.fetchData()
          }).catch(error => {
            this.loadingActive = false
            console.log('error', error)
            this.$refs['update_pt_price'].hide()
          })

        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    toSnakeCase(str) {
      return str.trim().replace(/\s+/g, '_').toLowerCase();
    },
    changeBranch(event) {
      this.getPt()
      this.personal_trainer_id = null
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/usage_log?sorting=' + this.sortBy
        + '&limit=' + this.paginationLimit
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + dates1[0]
        + '&end_date=' + dates1[1]

      if (event != null) {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },

    getPt() {
      if (Auth.Session.get().paradigm_role != 7) {
        let url = 'fitness/v1/personal_training?'
        if (this.branch_id != null) {
          url += 'branch_id=' + this.branch_id
        }
        this.optionsPT = [
          { value: null, text: 'Please select' }
        ]
        axios.get(url).then(response => {
          // this.items = response.data.data.rows
          response.data.data.rows.forEach(element => {
            this.optionsPT.push(
              { value: element.id, text: element.name }
            )
          });
          // this.totalPage = response.data.meta.pageCount
          // console.log(response)
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      if (Auth.Session.get().paradigm_role == 7) {
        axios.get('crm/v1/pt_report/usage_log?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&start_date=' + dates1[0] + '&end_date=' + dates1[1]).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.data.count.length

        }).catch(error => {
          console.log('error', error)
        })
      } else {
        let url = 'crm/v1/pt_report/usage_log?page=' + this.currentPage
          + '&limit=' + this.paginationLimit
          + '&sorting=' + this.sortBy
          + '&sorting_type=' + this.sortType
          + '&keyword=' + this.searchData
          + '&start_date=' + dates1[0]
          + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }
        if (this.personal_trainer_id != null) {
          url += '&personal_trainer_id=' + this.personal_trainer_id
        }

        axios.get(url).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.data.count.length

        }).catch(error => {
          console.log('error', error)
        })


      }
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
    this.getPt()
  }
}
</script>

<style></style>
